import { createAsyncThunk } from "@reduxjs/toolkit";

import type { UpdateDeploymentProps } from "../types";
import type { Deployment } from "@packages/client";
import type { AsyncThunkOptionType } from "Reducers/types";

export const updateDeployment = createAsyncThunk<
  Deployment,
  UpdateDeploymentProps,
  AsyncThunkOptionType
>(
  "app/environmentDeployment/update",
  async ({ deployment, data }, { rejectWithValue }) => {
    try {
      const result = await deployment.update(data);

      const updateDeployment: Deployment = result.getEntity();

      return updateDeployment;
    } catch (error) {
      return rejectWithValue(error as { code: number; message: string });
    }
  }
);
